export const LOAN_DETAILS_GS_QUERY = {
  widgetGroupId: 'TM_IAD_LOAN_CUSTOMERS',
  widgetId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET'
};

export const LOAN_DETAILS_MAP_NAMESPACE = 'TM_IAD.LoanDetails';

export const LOAN_DETAILS_WIDGET_SETTINGS = {
  pageId: 'TM_IAD_ALERTS_DETAILS',
  uiWidgetGroups: [
    {
      widgetGroupId: 'TM_IAD_LOAN_CUSTOMERS',
      widgetGroupIndex: 3,
      widgets: [
        {
          widgetId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET',
          widgetGroupId: 'TM_IAD_LOAN_CUSTOMERS',
          widgetName: 'Loan',
          widgetIndex: 0,
          isVisible: true,
          isDefault: false,
          widgetConfig: [
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_6',
              columnName: 'Column 6',
              columnIndex: 6,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'loanStructure',
                  itemLabel: 'Loan Type Description',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_20',
              columnName: 'Column 20',
              columnIndex: 20,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'totalRepaymentAmount',
                  itemLabel: 'Total Repayment Value',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_2',
              columnName: 'Column 2',
              columnIndex: 2,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'anticipatedSettlementDate',
                  itemLabel: 'Loan Maturity Date',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_16',
              columnName: 'Column 16',
              columnIndex: 16,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'accountClosedDate',
                  itemLabel: 'Account Close Date ',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_12',
              columnName: 'Column 12',
              columnIndex: 12,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'loanPurposeCode',
                  itemLabel: 'Loan Purpose Code',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_17',
              columnName: 'Column 17',
              columnIndex: 17,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'assetName',
                  itemLabel: 'Asset Name',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_5',
              columnName: 'Column 5',
              columnIndex: 5,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'loanCurrencyCode',
                  itemLabel: 'Account Currency',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_0',
              columnName: 'Column 0',
              columnIndex: 0,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'loanKey',
                  itemLabel: 'Account Number',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_23',
              columnName: 'Column 23',
              columnIndex: 23,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'c2ARelationship',
                  itemLabel: 'C2A Relationship',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_1',
              columnName: 'Column 1',
              columnIndex: 1,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'loanAmount',
                  itemLabel: 'Loan Amount',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_24',
              columnName: 'Column 24',
              columnIndex: 24,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'gLGroup',
                  itemLabel: 'Loan GL Group',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_13',
              columnName: 'Column 13',
              columnIndex: 13,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'loanInstallmentValue',
                  itemLabel: 'Instalment Amount',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_4',
              columnName: 'Column 4',
              columnIndex: 4,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'lastPaymentDate',
                  itemLabel: 'Last Payment Timestamp',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_22',
              columnName: 'Column 22',
              columnIndex: 22,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'loanRepaymentStructure',
                  itemLabel: 'Loan Repayment structure',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_8',
              columnName: 'Column 8',
              columnIndex: 8,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'advancePaymentCount',
                  itemLabel: 'Advance Payment Count',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_25',
              columnName: 'Column 25',
              columnIndex: 25,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'nextInstallmentDate',
                  itemLabel: 'Next Installment Timestamp',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_14',
              columnName: 'Column 14',
              columnIndex: 14,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'statusCode',
                  itemLabel: 'Account Status',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_11',
              columnName: 'Column 11',
              columnIndex: 11,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'numberOfPayments',
                  itemLabel: 'Number of Payments',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_9',
              columnName: 'Column 9',
              columnIndex: 9,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'advancePaymentAmount',
                  itemLabel: 'Advance Payment Amount',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_21',
              columnName: 'Column 21',
              columnIndex: 21,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'loanFirstDisbursementDate',
                  itemLabel: 'Loan 1st Disbursement Date',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_7',
              columnName: 'Column 7',
              columnIndex: 7,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'accountName',
                  itemLabel: 'Loan Account Name',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_10',
              columnName: 'Column 10',
              columnIndex: 10,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'loanTypeCode',
                  itemLabel: 'Loan Type',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_19',
              columnName: 'Column 19',
              columnIndex: 19,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'natureOfTheAsset',
                  itemLabel: 'Loan Asset Type',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_15',
              columnName: 'Column 15',
              columnIndex: 15,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'accountOpenDate',
                  itemLabel: 'Account Opening Date',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_3',
              columnName: 'Column 3',
              columnIndex: 3,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'outstandingLoanBalance',
                  itemLabel: 'Outstanding Balance',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            },
            {
              columnId: 'TM_IAD_LOAN_CUSTOMERS_WIDGET_C_18',
              columnName: 'Column 18',
              columnIndex: 18,
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemName: 'nameOfTheOwnerOfTheAsset',
                  itemLabel: 'Loan Asset Owner Name',
                  itemIndex: 0,
                  searchEnabled: false,
                  sortEnabled: false,
                  filterEnabled: false,
                  visibility: true
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
